import { render, staticRenderFns } from "./ApiClientForm.vue?vue&type=template&id=09735b2e"
import script from "./ApiClientForm.vue?vue&type=script&lang=js"
export * from "./ApiClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports